import { render, staticRenderFns } from "./VersionSearchResultDetail.vue?vue&type=template&id=198902a6&scoped=true&"
import script from "./VersionSearchResultDetail.vue?vue&type=script&lang=js&"
export * from "./VersionSearchResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./VersionSearchResultDetail.vue?vue&type=style&index=0&id=198902a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198902a6",
  null
  
)

component.options.__file = "VersionSearchResultDetail.vue"
export default component.exports